
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/panduan-konsumen/biaya-denda-dan-bunga",
      function () {
        return require("private-next-pages/panduan-konsumen/biaya-denda-dan-bunga.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/panduan-konsumen/biaya-denda-dan-bunga"])
      });
    }
  